export default __webpack_public_path__ + "static/media/background_synthesis.5bad857a.png";